<span class="badge badge-{{ variant }} badge-{{ size }} text-uppercase p-1 px-2" [title]="text"
  ><ng-content select="[badge-icon]"></ng-content>{{ text }}</span
>
